<% var component = new Anvil.models.components.ExamTimer(params) %>
<span anvil-component="<%- component.id %>"></span>
